import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/deposits/profile/loading';

export const Route = createFileRoute('/_private/deposits/$id')({
  pendingComponent: Loading,
});
